module.exports = __webpack_public_path__ + "img/team-name.9a9009f3.png";